import React from "react";
import VideoCarousel from "./VideoCarousel";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Add this import

const VideoSeries = () => {
  const { t } = useTranslation(); // Add translation hook

  return (
    <div className="px-4 sm:px-6 py-8 sm:py-16 bg-[#F9D3CF] mb-4">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl mb-10 text-center w-full relative inline-block after:block after:w-20 after:h-1 after:bg-[#902828] after:mx-auto after:mt-2">
          {t("videoSeries.sectionTitle")}
        </h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-6">{t("videoSeries.introText")}</p>
        <div className="flex flex-col sm:flex-row gap-6 sm:justify-between sm:items-end mb-8">
          <div className="max-w-3xl">
            <p className="text-base sm:text-lg text-gray-600 mb-4">
              {t("videoSeries.paragraph1.beforeHighlight")}{" "}
              <span className="text-[#B82A1E] font-semibold">
                {t("videoSeries.paragraph1.highlight")}
              </span>
              {t("videoSeries.paragraph1.afterHighlight")}
            </p>
            <p className="text-base sm:text-lg text-gray-600">{t("videoSeries.paragraph2")}</p>
          </div>
          <Link
            to="/video-series"
            className="group relative overflow-hidden bg-gradient-to-r from-[#B82A1E] to-[#8a1f16] text-white font-medium py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto"
          >
            {t("videoSeries.exploreButton")}
          </Link>
        </div>
      </div>

      {/* Wrapper to control overflow */}
      <div className="w-full overflow-hidden px-0">
        <VideoCarousel />
      </div>

      <div className="mt-8 sm:mt-12 text-center text-lg sm:text-xl text-gray-700 italic px-4">
        {t("videoSeries.quote")}
      </div>
    </div>
  );
};

export default VideoSeries;
